<template>
  <div v-if="bookMarkVisible">
    <div v-if="this.markMode === 'SIMPLE'">
      <div
        class="book-mark-card-simple-dark flex-start-between"
        v-if="darkMode"
        @click="selectWebMark"
      >
        <div class="flex-start-conent">
          <div class="card-img-simple">
            <img v-bind:src="bookMarkInfo.icon" v-if="bookMarkInfo.icon" />
            <img src="../../assets/img/logo.png" v-else />
          </div>
          <div class="card-title-simple">
            {{ bookMarkInfo.name }}
          </div>
        </div>

        <div class="book-mark-card-simple-toolbar-dark">
          <a-radio :checked="selected"></a-radio>
        </div>
      </div>

      <div class="book-mark-card-simple flex-start-between" v-else>
        <div class="flex-start-conent" @click="open()">
          <div class="card-img-simple">
            <img v-bind:src="bookMarkInfo.icon" v-if="bookMarkInfo.icon" />
            <img src="../../assets/img/logo.png" v-else />
          </div>
          <div class="card-title-simple">
            {{ bookMarkInfo.name }}
          </div>
        </div>
        <a-dropdown :trigger="['click']">
          <div class="cycle">
            <div>
              <a-icon class="center-y" type="more" />
            </div>
          </div>
          <a-menu slot="overlay" class="menu-list">
            <a-menu-item>
              <span
                　　v-clipboard:copy="bookMarkInfo.url"
                　　v-clipboard:success="copyLink"
                　　style="cursor: copy;"
                　　
              >
                <div>分享</div>
              </span>
            </a-menu-item>
            <a-menu-item>
              <div @click="openPasswordManage">密码</div>
            </a-menu-item>
            <a-menu-item v-if="canEdit">
              <div @click="openBookmarkEdit">编辑</div>
            </a-menu-item>
            <a-menu-item v-if="canEdit">
              <a-popconfirm
                title="确认删除吗?"
                placement="top"
                ok-text="确认"
                cancel-text="取消"
                @confirm="deleteBookMark"
              >
                <div>删除</div>
              </a-popconfirm>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </div>
    </div>
    <div v-else>
      <div v-if="darkMode">
        <div class="book-mark-card-basic-dark" @click="selectWebMark">
          <div class="book-mark-card-info-dark">
            <div class="card-img">
              <img v-bind:src="bookMarkInfo.icon" v-if="bookMarkInfo.icon" />
              <img src="../../assets/img/logo.png" v-else />
            </div>
            <div class="card-text-contener">
              <div class="card-title">{{ bookMarkInfo.name }}</div>
              <div class="card-content">
                {{ bookMarkInfo.description }}
              </div>
            </div>
            <div class="checkbox-right">
              <a-radio :checked="selected"></a-radio>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="book-mark-card-basic" :style="{background:colorValue}">
          <div class="book-mark-card-info" @click="open()">
            <div class="card-img">
              <img v-bind:src="bookMarkInfo.icon" v-if="bookMarkInfo.icon" />
              <img src="../../assets/img/logo.png" v-else />
            </div>
            <div class="card-text-contener">
              <div class="card-title">{{ bookMarkInfo.name }}</div>
              <div class="card-content">
                {{ bookMarkInfo.description }}
              </div>
            </div>
          </div>
          <div class="card-tool-bar">
            <div class="tool-bar-flex">
              <div class="tool-bar-text">
                <div @click="openShare">
                  分享
                  <Share 
                  :favId="bookMarkInfo.id"
                  :showShare = "showShare"
                  @closeShare = "closeShare"
                  v-if="showShare"
                  ></Share>
                </div>
              </div>
              <div class="tool-bar-text" @click="openPasswordManage">密码</div>
              <div
                class="tool-bar-text"
                @click="openBookmarkEdit"
                v-if="canEdit"
              >
                编辑
              </div>
              <div
                class="tool-bar-text"
                @click="cleanRecord"
                v-if="!canEdit"
              >
                清除访问记录
              </div>
              <a-popconfirm
                title="确认删除吗?"
                placement="top"
                ok-text="确认"
                cancel-text="取消"
                @confirm="deleteBookMark"
              >
                <div class="tool-bar-text" v-if="canEdit">删除</div>
              </a-popconfirm>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modle-box">
      <div id="password-manage">
        <a-modal
          v-model="passwordManageVisible"
          title="密码信息"
          @ok="savePwd"
          centered
          okText="保存"
          cancelText="关闭"
        >
          <div class="model-form">
            <div class="model-form-item">
              <div class="model-form-item-label">账号:</div>
              <div class="model-form-item-input">
                <a-input placeholder="登录该网站的账号" v-model="psw.account" />
                <div class="model-form-item-input-tag">
                  <span
                    　　v-clipboard:copy="psw.account"
                    　　v-clipboard:success="copyLink"
                    　　style="cursor: copy;"
                  >
                    <a-tag color="blue">复制</a-tag>
                  </span>
                </div>
              </div>
            </div>
            <div class="model-form-item">
              <div class="model-form-item-label">密码:</div>
              <div class="model-form-item-input">
                <a-input-password
                  placeholder="登录该网站的密码"
                  v-model="psw.password"
                />
                <div class="model-form-item-input-tag">
                  <span
                    　　v-clipboard:copy="psw.password"
                    　　v-clipboard:success="copyLink"
                    　　style="cursor: copy;"
                  >
                    <a-tag color="blue">复制</a-tag>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </a-modal>
      </div>

      <div id="edit-bookmark">
        <a-modal
          v-model="bookmarkEditVisible"
          title="书签信息"
          @ok="saveBookmark"
          @cancel="closeSave"
          centered
          okText="保存"
          cancelText="关闭"
        >
          <a-form
            :form="form"
            :label-col="{ span: 6 }"
            :wrapper-col="{ span: 14 }"
            @submit="saveBookmark"
          >
            <a-form-item label="书签地址：">
              <a-input
                v-decorator="[
                  'url',
                  {
                    initialValue: bookMarkInfo.url,
                    rules: [
                      { required: true, message: '请输入书签地址!' },
                      { type: 'url', message: '请输入正确格式的网址！' },
                    ],
                  },
                ]"
              />
            </a-form-item>
            <a-form-item label="书签名称">
              <a-input
                v-decorator="[
                  'name',
                  {
                    initialValue: bookMarkInfo.name,
                    rules: [{ required: true, message: '请输入书签名称!' }],
                  },
                ]"
              />
            </a-form-item>
            <a-form-item label="快捷指令">
              <a-input
                v-decorator="[
                  'shortcut',
                  {
                    initialValue: bookMarkInfo.shortcut,
                  },
                ]"
              >
                <a-tooltip
                  slot="suffix"
                  title="使用Ctrl+Q按键呼出快捷指令输入口，再输入此指令可以快速打开此链接！"
                >
                  <a-icon
                    type="info-circle"
                    style="color: rgba(0, 0, 0, 0.45)"
                  />
                </a-tooltip>
              </a-input>
            </a-form-item>
             <a-form-item label="书签颜色">
              <a-input
               placeholder='点击右测方块选择颜色'
               disabled
                v-decorator="[
                  'color',
                  {
                    initialValue: bookMarkInfo.color,
                  },
                ]"
              >
                <a-tooltip
                  slot="suffix"
                  title="点击选择你喜欢的颜色！"
                >
                  <colorPicker v-model="bookMarkInfo.color" />
                </a-tooltip>
              </a-input>
            </a-form-item>
            <a-form-item label="描述">
              <a-textarea
                placeholder="网站备注"
                :auto-size="{ minRows: 2, maxRows: 5 }"
                v-decorator="[
                  'description',
                  {
                    initialValue: bookMarkInfo.description,
                  },
                ]"
              />
            </a-form-item>
          </a-form>
        </a-modal>
      </div>
    </div>
  </div>
</template>

<script>
import Share from './share.vue';
export default {
  data() {
    return {
      bookMarkVisible: true,
      passwordManageVisible: false,
      bookmarkEditVisible: false,
      psw: {
        account: "",
        password: "",
      },
      bookMarkInfo: this.bookMarkDetail,
      form: this.$form.createForm(this, { name: "coordinated" }),
      selected: false,
      initColor:'',
      showShare:false,
    };
  },
  components:{Share},
  props: [
    "bookMarkDetail",
    "selectIds",
    "showSelect",
    "markMode",
    "deleteById",
    "canEdit",
    "changeColor"
  ],
  methods: {
    open() {
      let newWindow = window.open(this.bookMarkInfo.url);
      newWindow.opener = null;
      this.$req.post(
        "/api/open-url-record/create",
        {
          favId: this.bookMarkInfo.id,
        },
        (res) => {}
      );
    },
    copyLink() {
      this.$message.success("复制成功！");
    },
    openPasswordManage() {
      let that = this;
      this.$req.get(
        "/api/password/select-by-fav/" + this.bookMarkInfo.id,
        {},
        (res) => {
          if (res.data) {
            that.psw = res.data;
          }
        }
      );
      this.passwordManageVisible = true;
    },
    savePwd() {
      this.psw.favoritesId = this.bookMarkInfo.id;
      let that = this;
      this.$req.post("/api/password/save", this.psw, (res) => {
        that.passwordManageVisible = false;
        this.$message.success("保存成功！");
      });
    },
    deleteBookMark() {
      let that = this;
      this.$req.get(
        "/api/favorites/delete/" + this.bookMarkInfo.id,
        {},
        (res) => {
          that.psw = res.data;
          that.bookMarkVisible = false;
          this.$message.success("删除成功！");
          that.deleteById(this.bookMarkInfo.id);
        }
      );
    },
    cleanRecord(){
       let that = this;
      this.$req.get("/api/open-url-record/delete/last/" + this.bookMarkInfo.id,{},(res)=>{
          that.psw = res.data;
          that.bookMarkVisible = false;
          this.$message.success("清除成功！");
          that.deleteById(this.bookMarkInfo.id);
      })
    },
    openBookmarkEdit() {
      this.bookmarkEditVisible = true;
    },
    saveBookmark(e) {
      let that = this;
      e.preventDefault();
      this.form.validateFields((result, formData) => {
        if (!result) {
          this.bookMarkInfo.name = formData.name;
          this.bookMarkInfo.url = formData.url;
          this.bookMarkInfo.description = formData.description;
          this.bookMarkInfo.shortcut = formData.shortcut;
          this.$req.post("/api/favorites/save", this.bookMarkInfo, (res) => {
            that.bookmarkEditVisible = false;
            this.$message.success("保存成功！");
          });
        }
      });
    },
    selectWebMark(e) {
      this.selected = !this.selected;
      let id = this.bookMarkInfo.id;
      if (this.selected) {
        this.selectIds.push(id);
      } else {
        this.selectIds.splice(this.selectIds.indexOf(id), 1);
      }
    },
    closeSave(){
       this.bookMarkDetail.color = this.initColor;
    },
    openShare(){
      this.showShare = true;
    },
    closeShare(){
       this.showShare = false;
    }
  },
  created(){
    this.initColor = this.bookMarkDetail.color;
  },
  computed: {
    darkMode() {
      this.selected = false;
      return this.showSelect;
    },
    colorValue(){
      if(this.changeColor){
        return this.bookMarkInfo.color ? this.bookMarkInfo.color : '#fff';
      }else{
        return '#fff';
      }
    },
  },
};
</script>

<style scoped>
.book-mark-card-basic:hover {
  box-shadow: 0 4px 16px 0 rgba(0,0,0,.1);
  cursor: pointer;
}
.book-mark-card-simple:hover{
  box-shadow: 0 4px 16px 0 rgba(0,0,0,.1);
  cursor: pointer;
}
.book-mark-card-basic:hover .card-tool-bar {
  display: block;
}

.card-img {
  float: left;
  width: 30px;
  height: 30px;
  margin: 0px 24px;
}
.card-img img {
  width: 100%;
  height: 100%;
}
.card-img-simple {
  width: 40px;
  height: 40px;
  margin: 0px 24px;
}
.card-img-simple img {
  width: 100%;
  height: 100%;
}
.card-text-contener {
  width: 150px;
  height: 70px;
  float: left;
}
.card-tool-bar {
  width: 100%;
  height: 30px;
  display: none;
}
.tool-bar-flex {
  height: 100%;
  width: 100%;
  padding-top: 8px;
  display: flex;
  justify-content: space-around;
  background: #f8fafb;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
}

.card-content {
  margin-top: 5px;
  font-family: FZLanTingHei-R-GBK;
  font-style: normal;
  font-weight: normal;
  font-size: 11px;
  line-height: 18px;
  letter-spacing: 0.05em;
  color: #8697a8;
  word-break: break-all;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.card-title {
  font-family: FZLanTingHei-R-GBK;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 23px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.card-title-simple {
  font-family: FZLanTingHei-R-GBK;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 23px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 160px;
}
.book-mark-card-simple-toolbar {
  padding-top: 15px;
  margin-right: 15px;
}
.book-mark-card-simple-toolbar-dark {
  padding-top: 5px;
  margin-right: 15px;
}
.tool-bar-text {
  font-family: FZLanTingHei-R-GBK;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 18px;
  color: #8697a8;
}
.tool-bar-text:hover {
  color: #19a0fb;
}
.checkbox-right {
  float: left;
  margin-top: 25px;
  margin-left: 35px;
}
.cycle {
  height: 40px;
  width: 40px;
  box-sizing: border-box;
  margin-top: -4px;
  margin-right: 6px;
  border: 20px solid rgba(1, 1, 1, 0);
  border-radius: 50%;
  opacity: 0;
}
.book-mark-card-simple:hover .cycle {
  border: 20px solid rgba(1, 1, 1, 0.1);
  opacity: 1;
}
.cycle div {
  margin-top: -10px;
  margin-left: -6px;
}
</style>